import { FormikProvider, useFormik } from 'formik'

import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'
import { getFieldNames, makeReqStringSchema } from '@/base'
import { Button, Dialog, Form, RadioGroupItem } from '@/ui'
import {
  createSmsConsentStatus,
  getSmsConsentStatus,
  SmsConsentSource,
  SmsConsentStatusOption,
} from './smsConsentReducer'

export const EditSmsConsentDialog = () => {
  const dispatch = useAppDispatch()
  const smsConsentStatus = useReselector(getSmsConsentStatus)

  const formik = useFormik({
    initialValues: {
      mobilePhoneNumber: smsConsentStatus?.mobilePhoneNumber || '',
      doesConsent: (
        smsConsentStatus?.status === SmsConsentStatusOption.OPT_IN
      ).toString(),
    },
    onSubmit: async (values) => {
      const doesConsent = values.doesConsent === 'true'

      await dispatch(
        createSmsConsentStatus({
          mobilePhoneNumber: doesConsent ? values.mobilePhoneNumber : null,
          source: SmsConsentSource.PRACTICE_PROFILE,
          status: doesConsent
            ? SmsConsentStatusOption.OPT_IN
            : SmsConsentStatusOption.OPT_OUT,
        })
      )
    },
  })

  const { values, submitForm, isSubmitting } = formik
  const fieldNames = getFieldNames(formik)

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <Button variant="link">Edit</Button>
      </Dialog.Trigger>

      <Dialog.Content>
        <Dialog.Title className="mb-2">Edit SMS Consent</Dialog.Title>

        <FormikProvider value={formik}>
          <Form.RadioGroup
            name={fieldNames.doesConsent}
            label="Opt in/out of SMS notifications"
            schema={makeReqStringSchema({})}
          >
            <RadioGroupItem
              value="true"
              label="I would like to receive SMS notifications"
            />
            <RadioGroupItem
              value="false"
              label="I do not want to receive SMS notifications"
            />
          </Form.RadioGroup>

          {values.doesConsent && (
            <Form.Input
              name={fieldNames.mobilePhoneNumber}
              label="Your mobile phone number"
              componentType="phone"
            />
          )}
        </FormikProvider>

        <Dialog.Footer className="mt-2">
          <Dialog.Close asChild>
            <Button variant="secondary">Close</Button>
          </Dialog.Close>

          <Dialog.Close asChild>
            <Button
              onClick={submitForm}
              disabled={isSubmitting}
              loading={isSubmitting}
            >
              Save
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
